import propTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Col, Title, Subtitle, ButtonSubmit } from '../styles';
import { clearMfaFlow } from '../mfaFlowStorage';
import { IconBadge, ShieldIcon, Centered, Actions } from './styles';

const LoginMfaInvite = ({ values, auth, setCurrentStep, steps }) => {
  const [t] = useTranslation('login');
  const history = useHistory();
  // mfaEnrollmentSession presente = modo obrigatório (ver useLoginActions):
  // sem "Deixar para depois" e com copy própria.
  const isMandatory = !!values.mfaEnrollmentSession;

  const handleSkip = () => {
    clearMfaFlow();
    history.push({
      pathname: 'products',
      state: { ...values.mfaUser, redirectUri: auth.redirectUri },
    });
  };

  return (
    <Col>
      <IconBadge>
        <ShieldIcon size={24} />
      </IconBadge>
      <Centered>
        <Title>
          {t(
            isMandatory
              ? 'two-step.enroll.invite-mandatory-title'
              : 'two-step.enroll.invite-title',
          )}
        </Title>
        <Subtitle>
          {t(
            isMandatory
              ? 'two-step.enroll.invite-mandatory-subtitle'
              : 'two-step.enroll.invite-subtitle',
          )}
        </Subtitle>
      </Centered>
      <Actions>
        <ButtonSubmit
          block
          color="primary"
          onClick={() => setCurrentStep(steps.mfaInstall)}
        >
          {t(
            isMandatory
              ? 'two-step.enroll.invite-mandatory-cta'
              : 'two-step.enroll.configure',
          )}
        </ButtonSubmit>
        {!isMandatory && (
          <Button block outline color="primary" onClick={handleSkip}>
            {t('two-step.enroll.skip')}
          </Button>
        )}
      </Actions>
    </Col>
  );
};

export default LoginMfaInvite;

LoginMfaInvite.propTypes = {
  values: propTypes.object.isRequired,
  auth: propTypes.object.isRequired,
  setCurrentStep: propTypes.func.isRequired,
  steps: propTypes.object.isRequired,
};
